export const clientId = '21cd6b26-8871-463f-89a2-37d1b7848527';
export const version = '1.0.9';
export const coc00nApiUrl = 'https://coc00napi.azurewebsites.net/api/';
export const coc00nApiScope = 'api://coc00n_api/read';
export const coc00nApiRedirectUrl = [...coc00nApiUrl.split('/').slice(0, 3), '.auth/login/aad'].join('/');
export const pushPublicKey = 'BA2eUp01-7u8I4euq_xIMX-zEDkU5P6nL_N9CSU5M4w-fX4c-pOoqHYcq4jm_Y2qBzCVl4aCp2q0_88UEN797m0';
